module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill-opacity=\"14.118\" viewBox=\"0 0 640 480\" fill=\"#28ff09\"><g fill-rule=\"evenodd\" fill-opacity=\"1\"><path fill=\"red\" d=\"M0 0h640v160.683H0z\"/><path fill=\"#fff\" d=\"M0 160.683h640V321.55H0z\"/><path fill=\"#0098ff\" d=\"M0 321.55h640v158.448H0z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/lu.svg
// module id = 53
// module chunks = 0